import React, { Component } from 'react'
import './css/App.scss'
import { connect } from 'react-redux'
import { withRoutingTracker } from './js/HOC/withRoutingTracker.js'
import {
  getAttributeTermsById,
  getCushionsByCategory,
  setCushionDimensions,
  setCushionFasteners,
  setCushionFillings,
  setCushionSets,
  setCushionShapes,
  setCushionStyles,
  setCushionTypes,
  setInitialCushionDimensions,
  setIsHalfInchRemoved,
} from './js/actions/cushionActions.js'
import DefaultRouter from './js/routers/DefaultRouter.js'
import FillingOnlyRouter from './js/routers/FillingOnlyRouter.js'
import DeepSeatingRouter from './js/routers/DeepSeatingRouter.js'
import CustomDeepSeatingRouter from './js/routers/CustomDeepSeatingRouter.js'
import { setCurrentFlow } from './js/actions/layoutActions.js'
import {
  getFabricById,
  resetGeneral,
  setAdditionalShape,
  setCanProceedToNextStep,
  setCategory,
  setCordFabricDirection,
  setCustomTamplateNumberOfFasteners,
  setFabricDirection,
  setFastenerPlacement,
  setIndividualRoundedBack,
  setIndividualRoundedSeat,
  setProductQty,
  setRemoveItem,
  setSelectedCordFabric,
  setSelectedDimensions,
  setSelectedFabric,
  setSelectedFastener,
  setSelectedFilling,
  setSelectedSet,
  setSelectedShape,
  setSelectedStyle,
  setSelectedType,
  setZipperOrientation,
} from './js/actions/generalActions.js'
import {
  getBrands,
  getColorMap,
  getCordingFabrics,
  getFabrics,
  getMaterials,
  getPatterns,
  getUses,
} from './js/actions/fabricsActions.js'
import { getUser } from './js/actions/userActions.js'
import _ from 'lodash'
import { DIMENSION_ATTRIBUTES, ITEM_ORDERING, SHAPE_ATTRIBUTES_MAP } from './js/utils/config.js'
import PillowRouter from './js/routers/PillowRouter.js'
import StandalonePagesRouter from './js/routers/StandalonePagesRouter.js'
import {
  getDimensionsFromParams,
  getEstimate,
  mapOrder,
  redirectTo,
  toggleDeepSeatingView,
} from './js/utils/utils.js'
import KitsRouter from './js/routers/KitsRouter.js'

class CushionDesigner extends Component {
  componentDidMount() {
    const { params, dispatch, history, general, location } = this.props
    const { fabric, cordFabric } = general
    if (!window.location.href.includes('kit')) {
      if (params.category) {
        let flow = 'default'

        switch (params.category) {
          case '28':
            if (params.type?.custom) {
              toggleDeepSeatingView(dispatch, false)()
              flow = 'custom-deep-seating'
            } else {
              flow = 'deep-seating'
            }
            break
          case '27':
            flow = 'pillow'
            break
          case '2893':
            flow = 'filling-only'
            break
        }

        if (params.category !== 'category') {
          dispatch(setCategory(parseInt(params.category)))
        }

        dispatch(setCurrentFlow(flow))

        const promises = ['27', '28', '769', '884', '2893'].map((category) =>
          getCushionsByCategory(category),
        )

        Promise.all(promises).then((cushions) => {
          let orderedCushions = [...cushions.flat()]
          orderedCushions = mapOrder(orderedCushions, ITEM_ORDERING.CUSHION_DESIGNER_TYPES, 'id')
          dispatch(setCushionTypes(orderedCushions))
          if (params.type.id) {
            if (params.type.id !== 'type') {
              this._getAllDataFromAPI(dispatch, orderedCushions)
            }
          }
        })
      } else {
        dispatch(setCurrentFlow('standalone-pages'))
      }
    }

    const apiParams = [
      {
        name: 'per_page',
        value: '100',
      },
      {
        name: 'page',
        value: '1',
      },
    ]
    const apiParamsForCording = [
      {
        name: 'per_page',
        value: '100',
      },
      {
        name: 'page',
        value: '1',
      },
      {
        name: 'orderby',
        value: 'menu_order',
      },
      {
        name: 'order',
        value: 'asc',
      },
    ]

    window.addEventListener('resize', this._checkForMobileLayout)

    dispatch(getUser())
    dispatch(getCordingFabrics(apiParamsForCording))
    dispatch(getFabrics(apiParams))
    dispatch(getColorMap())
    dispatch(getMaterials())
    dispatch(getUses())
    dispatch(getBrands())
    dispatch(getPatterns())

    if (!fabric && params?.fasteners && params?.fabric?.id) {
      getFabricById(params?.fabric?.id).then((fabric) => {
        if (fabric) {
          dispatch(setSelectedFabric(fabric))
          dispatch(setFabricDirection(params?.fabric?.direction))
        } else {
          dispatch(setSelectedFabric(null))
          dispatch(setFabricDirection(null))
        }
      })
    }
    if (!cordFabric && params?.filling && params?.style?.fabricId !== 'fabric') {
      getFabricById(params?.style?.fabricId).then((fabric) => {
        if (fabric) {
          dispatch(setSelectedCordFabric(fabric))
          dispatch(setCordFabricDirection(params?.style?.fabricDirection))
        } else {
          dispatch(setSelectedCordFabric(null))
          dispatch(setCordFabricDirection(null))
        }
      })
    }

    setTimeout(() => {
      this._getPrice()
    }, 100)

    if (location.pathname.includes('removeitem')) {
      const removeItemUrl = 'removeitem' + location.pathname.split('removeitem')[1]
      const paramsArray = removeItemUrl.split('&')
      const paramsObject = paramsArray.map((param) => param.split('='))
      const paramsObjects = paramsObject.reduce((acc, curr) => {
        acc[curr[0]] = curr[1]
        return acc
      }, {})
      dispatch(setRemoveItem(paramsObjects))
      dispatch(setProductQty(paramsObjects.qty))
      const url = '/cd' + location.pathname.replace(/removeitem.*/, '')
      redirectTo(`${url}`, history)
    }

    if (window.location.href.includes('kit')) {
      setTimeout(() => {
        this._goToKits()
      }, 1500)
    }
  }

  componentDidUpdate(prevProps) {
    const { params, fabrics, cushion, dispatch, general, location } = this.props
    const { cushionTypes } = cushion
    const { fabric, cordFabric } = general

    if (window?.sendgtag && location?.pathname !== prevProps.location?.pathname) {
      window.sendgtag('page_view', null, null, 'Cushion Designer', location?.href)
    }

    if (window.location.href.includes('kit')) {
      return
    }

    if (_.isEmpty(params)) {
      return
    }

    if (params.type.id !== 'type' && !_.isEqual(prevProps.params.type.id, params.type.id)) {
      dispatch(resetGeneral())
      this._getAllDataFromAPI(dispatch, cushionTypes)
    }

    if (
      fabrics.fetchedFabrics &&
      !_.isEqual(prevProps.fabrics.fetchingFabrics, fabrics.fetchingFabrics)
    ) {
      this._getFabricsDataFromAPI(dispatch, fabrics)
      if (!fabric && params?.fasteners && params?.fabric?.id) {
        getFabricById(params?.fabric?.id)
          .then((fabric) => {
            if (fabric) {
              dispatch(setSelectedFabric(fabric))
              dispatch(setFabricDirection(params?.fabric?.direction))
            } else {
              dispatch(setSelectedFabric(null))
              dispatch(setFabricDirection(null))
            }
          })
          .then(() => {
            setTimeout(() => {
              this._getPrice()
            }, 100)
          })
      }
      if (!cordFabric && params?.filling && params?.style?.fabricId !== 'fabric') {
        getFabricById(params?.style?.fabricId)
          .then((fabric) => {
            if (fabric) {
              dispatch(setSelectedCordFabric(fabric))
              dispatch(setCordFabricDirection(params?.style?.fabricDirection))
            } else {
              dispatch(setSelectedCordFabric(null))
              dispatch(setCordFabricDirection(null))
            }
          })
          .then(() => {
            setTimeout(() => {
              this._getPrice()
            }, 100)
          })
      }
    }
  }

  _goToKits = () => {
    const { history, general, dispatch } = this.props
    const { user } = general
    if (!user.user_id) {
      dispatch(getUser()).then(() => {
        const userId = user.user_id

        dispatch(setCurrentFlow('kits'))
        redirectTo(`/kit/${userId}`, history)
      })
    } else {
      const userId = user.user_id

      dispatch(setCurrentFlow('kits'))
      redirectTo(`/kit/${userId}`, history)
    }
  }

  _getPrice = () => {
    const { dispatch, general, params } = this.props
    getEstimate(dispatch, general, params)()
  }

  _getFabricsDataFromAPI = (dispatch, fabrics) => {
    const { params, general } = this.props
    const { id: fabricId, direction: fabricDirection } = params.fabric || {}
    const {
      styleId,
      fabricDirection: styleFabricDirection,
      fabricId: styleFabricId,
    } = params.style || {}
    const { fabric, cordFabric } = general
    const ownFabric = {
      id: 'own',
      name: 'Customer Fabric',
    }

    if (fabricId && fabricId !== 'fabric' && !fabric) {
      dispatch(setFabricDirection(fabricDirection))
      const selectedFabric =
        fabricId === 'own'
          ? ownFabric
          : fabrics.fabrics.find((fabric) => fabric.id.toString() === fabricId.toString())
      const canProceed =
        params.fabric !== undefined &&
        Object.keys(params).length === (params.category === '28' && !params.type.custom ? 6 : 5)
      dispatch(setSelectedFabric(selectedFabric, canProceed ? canProceed : null))
    }

    if (styleId && styleId !== 'style' && !cordFabric) {
      dispatch(setCordFabricDirection(styleFabricDirection))
      const selectedFabric =
        styleFabricId === 'own'
          ? ownFabric
          : fabrics.fabrics.find((fabric) => fabric.id?.toString() === styleFabricId?.toString())
      const canProceed =
        params.style !== undefined &&
        Object.keys(params).length === (params.category === '28' && !params.type.custom ? 7 : 6)
      dispatch(setSelectedCordFabric(selectedFabric, canProceed ? canProceed : null))
    }
  }

  _getAllDataFromAPI = (dispatch, cushionTypes) => {
    const { params, general } = this.props
    const { individualRoundedBack, individualRoundedSeat } = general
    let currentType = cushionTypes.find((cushion) => cushion?.id === parseInt(params.type.id))
    if (!currentType) {
      return
    }

    const category = currentType.categories.filter((category) =>
      [27, 28, 769, 884, 2893].includes(category.id),
    )[0]?.id
    dispatch(setCategory(category))

    dispatch(setSelectedType({ ...currentType }))

    if (currentType.slug === 'filling-only') {
      dispatch(setCurrentFlow('filling-only'))
    }

    if (currentType.categories.find((category) => category.slug === 'deep-seating')) {
      dispatch({ type: 'FETCH_ATTRIBUTE_TERMS_BY_ID' })
      getAttributeTermsById(26).then((sets) => {
        let currentAttribute = currentType.attributes.find((attribute) => attribute.name === 'set')
        let filteredSets = sets.filter(
          (item) => currentAttribute.options.findIndex((option) => option === item.name) !== -1,
        )
        filteredSets = mapOrder(filteredSets, ITEM_ORDERING.SETS, 'id')
        dispatch(setCushionSets(filteredSets))

        if (params.set?.id !== 'set') {
          const selectedSet = filteredSets.find((set) => set.id === parseInt(params.set?.id))
          dispatch(setSelectedSet(selectedSet))
        }
      })
    }
    dispatch(setCushionShapes(null))
    let currentAttribute = currentType.attributes.find(
      (attribute) => attribute.id.toString() === '4',
    )

    if (currentAttribute) {
      getAttributeTermsById(currentAttribute.id).then((shapes) => {
        let filteredShapes = shapes.filter(
          (item) => currentAttribute.options.findIndex((option) => option === item.name) !== -1,
        )
        filteredShapes = mapOrder(filteredShapes, ITEM_ORDERING.SHAPES, 'id')
        const currentShape = params?.type.custom
          ? filteredShapes.find((shape) => shape?.id === 859)
          : filteredShapes.find((shape) => shape?.id.toString() === params?.shape?.id)
        const currentAdditionalShape = filteredShapes.find(
          (shape) => shape?.id.toString() === params?.shape?.additionalShapeId,
        )
        if (currentShape) {
          const canProceed =
            params.shape !== undefined &&
            Object.keys(params).length === (params.category === '28' ? 4 : 3)
          dispatch(setSelectedShape({ ...currentShape }, canProceed ? canProceed : null))

          if (params?.shape?.individuallyRounded && !individualRoundedBack) {
            dispatch(setIndividualRoundedBack(true))
          }
        }
        if (currentAdditionalShape) {
          dispatch(setAdditionalShape(currentAdditionalShape))
          if (params?.shape?.additionalShapeIndividuallyRounded && !individualRoundedSeat) {
            dispatch(setIndividualRoundedSeat(true))
          }
        }
        dispatch(setCushionShapes(filteredShapes))
        if (params.shape?.id || currentShape?.id) {
          if (
            params.shape?.id !== 'shape' &&
            params.type?.id !== '11569' &&
            params.category !== '28'
          ) {
            this._getDimensionsDataFromAPI(dispatch, { ...currentShape }, { ...currentType })
          }
        }
      })
    }
    if (
      params.category === '28' ||
      params.category === '27' ||
      params.type.id === '11569' ||
      params.type.id === '11741'
    ) {
      this._getDimensionsDataFromAPI(dispatch, { id: null }, currentType)
    }

    // filling
    getAttributeTermsById(15).then((fillings) => {
      let currentAttribute = currentType.attributes.find(
        (attribute) => attribute.id.toString() === '15',
      )

      if (!currentAttribute) {
        return
      }

      let filteredFillings = fillings.filter(
        (item) => currentAttribute.options.findIndex((option) => option === item.name) !== -1,
      )
      filteredFillings = mapOrder(filteredFillings, ITEM_ORDERING.FILLINGS, 'id')

      dispatch(setCushionFillings(filteredFillings))

      if (params.filling && params.filling !== 'filling') {
        const selectedFilling = filteredFillings.find(
          (filling) => filling.id?.toString() === params.filling,
        )
        dispatch(setSelectedFilling(selectedFilling))
      }
    })

    // style
    getAttributeTermsById(18).then((styles) => {
      const { styleId } = params.style || {}
      let currentAttribute = currentType.attributes.find(
        (attribute) => attribute.id.toString() === '18',
      )

      if (!currentAttribute) {
        return
      }

      let filteredStyles = styles.filter(
        (item) => currentAttribute.options.findIndex((option) => option === item.name) !== -1,
      )
      filteredStyles = mapOrder(filteredStyles, ITEM_ORDERING.STYLES, 'id')
      const newStyles = _.cloneDeep(filteredStyles)

      dispatch(setCushionStyles(newStyles))

      if (styleId && styleId !== 'style') {
        const selectedStyle = filteredStyles.find((style) => style.id?.toString() === styleId)
        dispatch(setSelectedStyle(selectedStyle))
      }
    })

    //fasteners
    if (params.category !== '27') {
      getAttributeTermsById(14).then((fasteners) => {
        const { fastenerId, fastenersPlacement } = params.fasteners || {}
        let currentAttribute = currentType.attributes.find(
          (attribute) => attribute.id.toString() === '14',
        )

        if (!currentAttribute) {
          return
        }

        let filteredFasteners = fasteners.filter(
          (item) => currentAttribute.options.findIndex((option) => option === item.name) !== -1,
        )

        if (fastenerId && fastenerId !== 'fasteners') {
          let selectedFastener
          if (params.type?.id === '11741') {
            selectedFastener = fasteners.find((fastener) => fastener.id?.toString() === fastenerId)
            dispatch(setSelectedFastener(selectedFastener))
            const noOfFasteners = params.fasteners?.fastenersPlacement?.mirroredCheckboxes || 1
            dispatch(setFastenerPlacement(noOfFasteners))
            dispatch(setCustomTamplateNumberOfFasteners(noOfFasteners))
            dispatch(setCanProceedToNextStep(true))
          } else {
            selectedFastener = filteredFasteners.find(
              (fastener) => fastener.id?.toString() === fastenerId,
            )
            dispatch(setSelectedFastener(selectedFastener))
            const fastenerPlacementCheckboxesParam = fastenersPlacement?.checkboxes
              .split('')
              .map(Number)
            const fastenerPlacementMirroredCheckboxesParam = fastenersPlacement?.mirroredCheckboxes
              .split('')
              .map(Number)
            dispatch(
              setFastenerPlacement({
                checkboxes: fastenerPlacementCheckboxesParam,
                mirroredCheckboxes: fastenerPlacementMirroredCheckboxesParam,
              }),
            )
            dispatch(
              setCanProceedToNextStep(
                fastenerPlacementCheckboxesParam
                  .concat(fastenerPlacementMirroredCheckboxesParam)
                  .some((item) => item === 1),
              ),
            )
          }
        }
        if (params.type?.id === '11741') {
          dispatch(setCushionFasteners(fasteners))
        } else {
          dispatch(setCushionFasteners(filteredFasteners))
        }
      })
    }
  }

  _getDimensionsDataFromAPI = (dispatch, shape, type) => {
    const { params, layout } = this.props
    const { typesStepView } = layout
    const cushionDimensions = {}
    const dimensionsParams = params.dimensions
    const zipperOrientation = dimensionsParams?.[dimensionsParams?.length - 1]

    dispatch(setZipperOrientation(parseInt(zipperOrientation)))

    SHAPE_ATTRIBUTES_MAP[
      typesStepView !== 'allTypes' || params.type?.custom ? 859 : shape.id || type.id
    ].map((dimensionId) => {
      let currentAttribute = type.attributes.find(
        (attribute) => attribute.id.toString() === dimensionId.toString(),
      )
      cushionDimensions[DIMENSION_ATTRIBUTES[dimensionId]] = currentAttribute?.options
    })

    if (params.dimensions) {
      const dimensionsFromParams = getDimensionsFromParams(cushionDimensions, params)
      dispatch(setSelectedDimensions(dimensionsFromParams))
    }

    dispatch(setInitialCushionDimensions(cushionDimensions))

    if (params.set) {
      const splitSetSlug = params.set.slug.split('-')
      const shouldRemoveHalfInch = parseInt(splitSetSlug[0]) > 1 || parseInt(splitSetSlug[2]) > 1

      if (shouldRemoveHalfInch) {
        const cushionDimensionsCopy = _.cloneDeep(cushionDimensions)
        cushionDimensionsCopy.width = [...cushionDimensions.width].filter((dimension) =>
          Number.isInteger(parseFloat(dimension)),
        )
        dispatch(setIsHalfInchRemoved(true))
        dispatch(setCushionDimensions(cushionDimensionsCopy))
      }
    }

    dispatch({ type: 'FETCH_ATTRIBUTE_TERMS_BY_ID_SUCCESS' })
  }

  render() {
    const { layout } = this.props
    const { currentFlow } = layout

    switch (currentFlow) {
      case 'default':
        return <DefaultRouter />
      case 'filling-only':
        return <FillingOnlyRouter />
      case 'deep-seating':
        return <DeepSeatingRouter />
      case 'pillow':
        return <PillowRouter />
      case 'standalone-pages':
        return <StandalonePagesRouter />
      case 'custom-deep-seating':
        return <CustomDeepSeatingRouter />
      case 'kits':
        return <KitsRouter />
      default:
        return null
    }
  }
}

const mapStateToProps = (state) => ({
  cushion: state.cushion,
  general: state.general,
  layout: state.layout,
  fabrics: state.fabrics,
})

export default withRoutingTracker(connect(mapStateToProps)(CushionDesigner))
